import { FC } from 'react';

import { TableNode, ViewNode } from '@/__generated__/graphql';
import { InheritedDescriptionDisplay } from '@/components/Description';
import { NO_DESCRIPTION } from '@/components/DescriptionForm';
import { DetailsSection } from '@/components/SectionWithCard';
import { GeneralAssetTable } from '../GeneralAssetTable';

type GeneralViewProps = {
  asset: TableNode | ViewNode | undefined;
  description: string | null | undefined;
};

export const GeneralView: FC<GeneralViewProps> = ({
  asset,
  description,
}: GeneralViewProps) => {
  return (
    <div className="opacity-1 duration-1000 motion-reduce:duration-0">
      {asset && (
        <>
          <DetailsSection heading="Description">
            <InheritedDescriptionDisplay
              description={description}
              defaultDescription={NO_DESCRIPTION}
              isDescriptionInherited={false}
              inheritedInfo={null}
              className="prose prose-sm w-full min-w-full dark:prose-invert"
            />
          </DetailsSection>
          <DetailsSection heading="Metadata" isCompact>
            <div>
              <GeneralAssetTable
                assetId={asset.urn}
                platform={asset.platform}
                entityType={asset.type}
              />
            </div>
          </DetailsSection>
        </>
      )}
    </div>
  );
};
